import React from "react";
import "./loading-styles.css";
const Loading = () => {
  return <div className="spinner"></div>;
};

export { Loading };
